import { DashboardArchivedAnalysis } from '@modules/dashboard/components/DashboardAnalysisContent/DashboardArchivedAnalysis';
import { DashboardQuantifyChart } from '@modules/dashboard/components/DashboardAnalysisContent/DashboardQuantifyChart';
import { FeedbackSummaryStoreProvider } from '@modules/oracle/feedbackSummaryStore/FeedbackSummaryStoreProvider';
import {
  AnalysisUseCase,
  AnalysisViewFragment,
  Status,
} from 'generated/graphql';
import { DashboardFeedAnalysisContent } from './DashboardFeedAnalysisContent';

interface DashboardAnalysisContentProps {
  analysis: AnalysisViewFragment;
  shouldDisableInteraction?: boolean;
}

export const DashboardAnalysisContent = ({
  analysis,
  shouldDisableInteraction,
}: DashboardAnalysisContentProps) => {
  if (analysis.status === Status.Archived) {
    return <DashboardArchivedAnalysis analysis={analysis} />;
  }

  if (analysis.useCase === AnalysisUseCase.Feed) {
    return (
      <FeedbackSummaryStoreProvider>
        <DashboardFeedAnalysisContent
          analysis={analysis}
          shouldDisableInteraction={shouldDisableInteraction}
        />
      </FeedbackSummaryStoreProvider>
    );
  }

  return (
    <DashboardQuantifyChart
      analysis={analysis}
      shouldDisableInteraction={shouldDisableInteraction}
    />
  );
};
